import { Link as RouterLink, type LinkProps as RouterLinkProps } from 'react-router-dom'
import { cx } from './utils'

type LinkVariant = 'primary' | 'secondary' | 'text'

export type LinkProps = RouterLinkProps & {
  variant?: LinkVariant
  disabled?: boolean
}

export function Link({ className, variant = 'text', disabled = false, onClick, ...props }: LinkProps) {
  return (
    <RouterLink
      className={cx('link', `link--${variant}`, disabled && 'is-disabled', className)}
      aria-disabled={disabled || undefined}
      tabIndex={disabled ? -1 : props.tabIndex}
      onClick={(event) => {
        if (disabled) {
          event.preventDefault()
          return
        }
        onClick?.(event)
      }}
      {...props}
    />
  )
}
